const MIN_WIDTH = 384;
const MAX_WIDTH = 496;

export { MAX_WIDTH, MIN_WIDTH };
